/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const accordionStyle = {
  accordionPaper: {
    backgroundColor: "transparent",
    boxShadow: "none",
    minHeight: "unset",
    borderRadius: "0.5rem",
    "&::before": {
      display: "none",
    },
  },
  accordionText: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&, &:last-of-type": {
      borderRadius: 0,
    },
    "&&": {
      margin: 0,
    },
    "&:first-of-type .MuiAccordionSummary-root": {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  }),
  summary: {
    "&.Mui-expanded": {
      minHeight: "unset",
    },
  },
  summaryOutlined: (theme: Theme) => ({
    borderRadius: "0.5rem",
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
  }),
  summaryOutlinedContent: {
    "&, &.Mui-expanded": {
      margin: "1rem 0",
    },
  },
  summaryContained: (theme: Theme) => ({
    borderRadius: "0.5rem",
    backgroundColor: theme.palette.primaryPale,
    boxShadow: theme.shadows[4],
  }),
  summaryContainedContent: {
    "&, &.Mui-expanded": {
      margin: "0.75rem 0",
    },
  },
  summaryText: {
    padding: 0,
  },
  summaryTextContent: {
    marginBlock: "2rem",
    "&.Mui-expanded": {
      marginBlock: "2rem",
    },
  },
  summaryActiveOutlined: (theme: Theme) => ({
    borderColor: theme.palette.primary.main,
  }),
  summaryContent: {
    width: "100%",
    alignItems: "center",
    gap: "1rem",
  },
  detailsOutlined: {
    padding: "1.5rem 1rem 0",
  },
  detailsContained: {
    padding: "1rem 0 0",
  },
  detailsText: {
    padding: "0 0 2rem",
  },
  detailsTitlePrefix: (theme: Theme) => ({
    paddingLeft: "4rem",
    [theme.breakpoints.up("md")]: {
      paddingLeft: "5rem",
    },
  }),
  titlePrefix: (theme: Theme) => ({
    width: "3rem",
    [theme.breakpoints.up("md")]: {
      width: "4rem",
    },
  }),
};
